// https://feathericons.dev/?search=archive&iconset=feather&format=strict-jsx
const SvgArchive = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            className="main-grid-item-icon"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            {...props}
            >
            <polyline points="21 8 21 21 3 21 3 8" />
            <rect height="5" width="22" x="1" y="3" />
            <line x1="10" x2="14" y1="12" y2="12" />
        </svg>
    );
}


export default SvgArchive;